import { useTranslation } from 'react-i18next';
import { Box, Divider, HStack, VStack } from 'native-base';

import { Address } from '@pimm/services/lib/sms-tenants';
import { HomeIcon } from '@pimm/base';
import { completeAddress } from '@app/utils/complete-address';
import { ReadOnlyField } from './read-only-field';
import Section from './section';

export const AddressBlock = ({ address }: { address?: Address }) => {
  const { t } = useTranslation();

  return (
    <Section.Card variant="form" title={t('store_settings:address')} icon={<HomeIcon size={4} color="gray.700" />}>
      <VStack space={4}>
        <HStack space={6} flexWrap="wrap">
          <Box flex={4}>
            <ReadOnlyField label={t('store_settings:street_address')} value={completeAddress(address)} />
          </Box>
        </HStack>

        <Divider />

        <HStack space={6} flexWrap="wrap">
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:time_zone')} value={address?.timeZoneId} />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:country')} value={address?.country} />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField
              label={t('store_settings:latitude')}
              value={address?.latitude !== null && address?.latitude !== undefined ? Number(address.latitude).toFixed(5) : undefined}
            />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField
              label={t('store_settings:longitude')}
              value={address?.longitude !== null && address?.longitude !== undefined ? Number(address.longitude).toFixed(5) : undefined}
            />
          </Box>
        </HStack>
      </VStack>
    </Section.Card>
  );
};
